import React from "react";

export function PhotoSvg({
                             width = "100%",
                             height = "100%",
                             bg = "#F1F5F9",
                             icon = "#94A3B8",
                             ...props
                         }) {
    return (
        <svg
            viewBox="0 0 300 300"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <defs>
                <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#F8FAFC"/>
                    <stop offset="100%" stopColor="#EEF2F7"/>
                </linearGradient>
            </defs>

            {/* Background */}
            <rect width="300" height="300" rx="24" fill="url(#bg)"/>

            {/* Soft image icon */}
            <g opacity="0.45">
                <rect
                    x="85"
                    y="95"
                    width="130"
                    height="100"
                    rx="14"
                    fill="#CBD5E1"
                />

                <circle cx="120" cy="125" r="8" fill="#F8FAFC"/>

                <path
                    d="M95 180l35-35 28 28 32-32 25 39H95z"
                    fill="#F8FAFC"
                />
            </g>
        </svg>
    );
}

export function ImagePlaceholder({
                                     ...props
                                 }) {
    return (
        <div style={{aspectRatio: "1 / 1", width: "100%"}}>
            <PhotoSvg/>
        </div>
    );
}

export default PhotoSvg
